module.exports = __webpack_public_path__ + "static/media/1.24.356fe17f.png";